import './App.css';
import Welcome from './components/welcome';
function App() {
  return (
    <div className="App">
      <div>
        <Welcome />
      </div>
    </div>
  );
}
export default App;
